import React, {useEffect, useState} from 'react';
import moment from 'moment';
import {loadNextPeriod, NEXT_PERIOD_CACHE_KEY} from "../../utils/localCache/nextPeriodCache";

const NextPeriod = () => {
    const [nextPeriod, updateNextPeriod] = useState(undefined);
    const [periodAbbreviation, updatePeriodAbbreviation] = useState('Period');
    const currentDate = Date.now();


    useEffect(() => {
        Promise.all([
            loadNextPeriod()
        ]).then((_loadNextPeriodResults) => {
            const cache = JSON.parse(window.localStorage.getItem(NEXT_PERIOD_CACHE_KEY));
            updateNextPeriod(cache.nextPeriod);
            updatePeriodAbbreviation(cache.periodAbbreviation);
        })
    }, []);

    // noinspection JSValidateTypes
    const daysUntilNextPeriod = moment(nextPeriod).diff(currentDate, 'days');
    return (<div className={"next-period-display"}>
            {`${periodAbbreviation} Release In ${daysUntilNextPeriod} Days.`}
        </div>
    );
};

export default NextPeriod;
